import React, { useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import "../css/LoginWithMpin.css";

export default function ForgotPassword() {
  const navigate = useNavigate();
  const [mobileNo, setMobileNo] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const handleResetPassword = async () => {
    if (!mobileNo.trim() || !newPassword.trim() || !confirmPassword.trim()) {
      toast.warn("Please fill all fields");
      return;
    }
    if (newPassword !== confirmPassword) {
      toast.error("Passwords do not match");
      return;
    }
    setIsLoading(true);
    try {
      const res = await axios.post(
        "https://admin.thedpboss.com/api/v1/reset-password",
        {
          mobileNo,
          newPassword,
          confirmPassword,
        },
        {
          headers: {
            "Content-Type": "application/json",
            deviceId: "WEB",
            deviceName: "WEB_BROWSER",
            accessStatus: 1,
          },
        }
      );
      if (res.data.status === true) {
        localStorage.setItem("mobileNo", mobileNo);
        localStorage.setItem("lastLoginMobileNo", mobileNo);
        toast.success("Password updated successfully.");
        navigate("/login-with-mpin", { replace: true });
      } else {
        toast.error(res.data.msg || "Failed to reset password.");
      }
    } catch (err) {
      toast.error("Something went wrong. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="mainhome-screen-wrapper">
      <div className="top-header">Reset Password</div>
      <div className="mpin-container" style={{ justifyContent: "flex-start", paddingTop: "60px" }}>
        <div className="mpin-card" style={{ boxShadow: "0 8px 32px rgba(0,0,0,0.08)", border: "1px solid #f0f0f0" }}>
          <h2 style={{ fontSize: "22px", color: "#121212", marginBottom: "30px" }}>Reset Password</h2>
          <div className="input-group" style={{ width: "100%", marginBottom: "20px" }}>
            {/* <input
              type="text"
              placeholder="Enter Mobile Number"
              className="mpin-input"
              style={{ textAlign: "center", fontSize: "18px" }}
              value={mobileNo}
              onChange={(e) => setMobileNo(e.target.value)}
            /> */}
            <input
  type="text"
  placeholder="Enter Mobile Number"
  className="mpin-input"
  style={{ textAlign: "center", fontSize: "18px" }}
  value={mobileNo}
  maxLength={10}   // 👈 ye add karo
  onChange={(e) => {
    const value = e.target.value.replace(/\D/g, ""); // 👈 only numbers allow
    setMobileNo(value);
  }}
/>
          </div>
          <div className="input-group" style={{ width: "100%", marginBottom: "20px" }}>
            <input
              type="password"
              placeholder="Enter New Password"
              className="mpin-input"
              style={{ textAlign: "center", fontSize: "18px" }}
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
            />
          </div>
          <div className="input-group" style={{ width: "100%", marginBottom: "20px" }}>
            <input
              type="password"
              placeholder="Confirm New Password"
              className="mpin-input"
              style={{ textAlign: "center", fontSize: "18px" }}
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
            />
          </div>
          <button
            className="mpin-login-btn"
            onClick={handleResetPassword}
            disabled={isLoading}
          >
            {isLoading ? "RESETTING..." : "RESET PASSWORD"}
          </button>
        </div>
      </div>
    </div>
  );
}
